import React from 'react';
import PrintableProjectDocument from './PrintableProjectDocument';

const ContractDetailsPDF = () => <PrintableProjectDocument type="contract" />;

export default ContractDetailsPDF;
